import { useEffect, useRef } from "react";

// Decorative motion only. Detection, thresholds and cooldowns remain in App.
export default function useShakeVisualMotion() {
  const artRef = useRef(null);
  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    let previous = null;
    let frame = 0;
    let reset;
    const onMotion = (event) => {
      if (media.matches || !event.accelerationIncludingGravity) return;
      const { x = 0, y = 0, z = 0 } = event.accelerationIncludingGravity;
      const current = [x || 0, y || 0, z || 0];
      if (previous) {
        const delta = current.reduce(
          (sum, value, i) => sum + Math.abs(value - previous[i]),
          0,
        );
        const angle =
          Math.min(9, delta * 0.8) * (current[0] >= previous[0] ? 1 : -1);
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() =>
          artRef.current?.style.setProperty("--motion-angle", `${angle}deg`),
        );
        clearTimeout(reset);
        reset = setTimeout(
          () => artRef.current?.style.setProperty("--motion-angle", "0deg"),
          180,
        );
      }
      previous = current;
    };
    window.addEventListener("devicemotion", onMotion, { passive: true });
    return () => {
      window.removeEventListener("devicemotion", onMotion);
      cancelAnimationFrame(frame);
      clearTimeout(reset);
    };
  }, []);
  return artRef;
}
